import type { WsV2TableEvent } from '../types';

export const updateV2SocketData = <D extends unknown>(
  prev: Record<string, D>,
  table: WsV2TableEvent<D>['data'],
): Record<string, D> | null => {
  let next: Record<string, D> = { ...prev };
  if (table.s) next = { ...table.s };

  if (table.d) {
    Object.keys(table.d).forEach((key) => {
      delete next[key];
    });
  }
  if (table.u) {
    // 1차원 object 만 지원
    Object.entries(table.u).forEach(([key, value]) => {
      if (next[key]) {
        next[key] = {
          ...next[key],
          ...value,
        };
      }
    });
  }
  if (table.i) {
    next = {
      ...table.i,
      ...next,
    };
  }

  return !Object.keys(next).length ? null : next;
};
